module.exports = __webpack_public_path__ + "media/images/flags/pm-086ebd78b096b1ae28e255151e9b5033.svg";